import { RootState } from 'store';

import { Development, DevelopmentDetailType } from 'types/promoters/promoterTypes';
import {
  FilterType,
  GetPropertyType,
  InitialViewType,
  PropertyType,
} from 'types/property/propertyTypes';

export const propertySliceSelector = (state: RootState) => state.propertySlice;

export const createActivePropertySelector = (state: RootState): PropertyType | undefined =>
  propertySliceSelector(state)?.activeProperty;

export const activeDevelopmentSelector = (state: RootState): DevelopmentDetailType | undefined =>
  propertySliceSelector(state)?.activeDevelopment;

export const watchedPropertiesSelector = (state: RootState): GetPropertyType[] | undefined =>
  propertySliceSelector(state)?.watchedProperties;

export const developmentListSelector = (state: RootState): Development[] | undefined =>
  propertySliceSelector(state)?.developmentList;

export const initialViewSelector = (state: RootState): InitialViewType | undefined =>
  propertySliceSelector(state)?.initialView;

export const termsSelector = (state: RootState): FilterType | undefined =>
  propertySliceSelector(state)?.terms;
